import { Input } from 'antd';
import styled from '@emotion/styled';

import { InputProps } from 'antd/es/input';

export interface HintInputProps extends InputProps {
  limit?: number;
  value?: string;
}

const Wrapper = styled.div<{ isOverflow: boolean }>(
  ({ theme, isOverflow }) => `
  .${theme.getAntdPrefixedClassName('input-affix-wrapper')} {
    font-size: inherit;
    ${
      isOverflow
        ? `
      &,
      &:hover,
      &:not(&-disabled) {
        color: #f5222d;
        border-color: #f5222d;
      }
      &-focused {
        border-color: #ff4d4f;
        outline: 0;
        box-shadow: 0 0 0 2px rgba(245, 34, 45, 0.2);
      }
    `
        : ''
    }
  }
`,
);

const Hint = styled.span<{ isOverflow: boolean }>`
  padding: 0 4px;
  border-radius: 2px;
  color: ${({ isOverflow }) => (isOverflow ? '#f5222d' : 'var(--fett-text-tertiary)')};
  background: var(--fett-bg-elevated);
  .${({ theme }) => theme.getAntdPrefixedClassName('input-disabled')}
    + .${({ theme }) => theme.getAntdPrefixedClassName('input-suffix')}
    & {
    background: transparent;
  }
`;

function HintInput(props: HintInputProps) {
  const { limit, value = '', ...otherProps } = props;

  const isOverflow = limit !== undefined && value.length > limit;

  const hint = limit !== undefined && (
    <Hint isOverflow={isOverflow}>{`${value.length} / ${limit}`}</Hint>
  );

  return (
    <Wrapper isOverflow={isOverflow}>
      <Input value={value} suffix={hint} {...otherProps} />
    </Wrapper>
  );
}

export default HintInput;
